// extracted by mini-css-extract-plugin
module.exports = {"container":"sa","categoryItem":"ta","active":"ua"};